export function toHighlightKeywords(query) {
  const tokens = (query ?? '').trim().split(/\s+/).filter(Boolean)
  if (tokens.length <= 1) return tokens[0] ?? ''
  return tokens
}

export function toPlainText(value) {
  const str = value == null ? '' : String(value)
  if (!str) return ''
  if (!/[<>]/.test(str)) return str
  if (typeof DOMParser === 'undefined') return str.replace(/<[^>]+>/g, '')
  return new DOMParser().parseFromString(str, 'text/html').body.textContent || ''
}
